import '@cta/frontend';

import '@campact/camper/core/CmprButton';
import '@campact/camper/icons/CmprIconSolidLock';
import '@campact/camper/core/CmprTicker';

import Rails from '@rails/ujs';

import './index.scss';

Rails.start();
